import React from "react";
import brandsmartLogo from "../Images/BrandsMartUSA_Logo.png";
import { useBranding } from "../utils/branding";

const HOMEIQ_GENERAL_LOGO = `${process.env.PUBLIC_URL}/HomeIQ-General-Logo.png`;

export function Logo() {
  const branding = useBranding();
  const is301io = branding.theme.id === "301io";

  const logoSrc = is301io ? HOMEIQ_GENERAL_LOGO : brandsmartLogo;
  const altText = is301io ? "HomeIQ Logo" : `${branding.brandName} Logo`;

  return (
    <div className="flex items-center">
      <img
        src={logoSrc}
        alt={altText}
        className={`${is301io ? 'h-14' : 'h-6'} w-auto object-contain`}
      />
    </div>
  );
}
